import { createAsyncThunk } from "@reduxjs/toolkit";
import { rdsSelectionGet } from "../../utils/rds";
import { rdsRunner_Dto, rdsRunner_ResponseDto } from "../../interfaces/dtos/rdsRunner";
import { apiUrls } from "../../components/shared/apiUrls";

interface LoadRdsRunnerArgs {
    selectionId: number;
    selectionStatus: string;
}

export const loadRdsRunner = createAsyncThunk(
    'rds/loadRdsRunner',
    async ({ selectionId, selectionStatus }: LoadRdsRunnerArgs) => {
        if (selectionStatus !== 'V') {
            const response = await rdsSelectionGet<rdsRunner_ResponseDto>(
                `${apiUrls.rdsSelections.getRunner(selectionId)}`
            );

            return response.data
        } else {
            return {
                id: selectionId,
                name: "Vacant",
                shortName: "Vacant",
                reserveName: "",
                trainer: 0,
                reserveTrainer: "",
                sex: "",
                colour: "",
            } as rdsRunner_Dto
        }
    }
);
